import React from 'react';
import _ from 'lodash';
import { ForgeCheckbox } from '@tylertech/forge-react';

import { I18n } from 'common/i18n';

interface Props {
  checked?: boolean;
  description: string;
  disabled: boolean;
  hidden?: boolean;
  id?: string;
  toggleCheckbox: () => void;
  preferenceName: string;
  preferenceType: string;
  preferenceTypeLabel: string;
}

const PreferenceTableCheckBox = ({
  checked,
  description,
  disabled,
  hidden,
  id,
  toggleCheckbox,
  preferenceName,
  preferenceType,
  preferenceTypeLabel,
}: Props) => {
  const scope = 'shared.site_chrome.notifications.alert_setting_modal';
  const checkboxId = id || _.uniqueId(preferenceName);
  const ariaLabel = `${I18n.t('table_header.feature', { scope })} ${description} ${I18n.t('table_header.notify_by', { scope })} ${preferenceTypeLabel}`;
  return (
    <div className={`preferences-checkbox ${preferenceType}`}>
      <ForgeCheckbox
        id={checkboxId}
        ariaLabel={ariaLabel}
        checked={checked && !hidden}
        onChange={toggleCheckbox}
        disabled={disabled}
        hidden={hidden}
      >
        {preferenceTypeLabel}
      </ForgeCheckbox>
    </div>
  );
};

export default PreferenceTableCheckBox;
